interface SoldRibbonProps {
  type?: "vendido" | "cancelado";
}

const SoldRibbon = ({ type = "vendido" }: SoldRibbonProps) => {
  const isCancel = type === "cancelado";
  return (
    <div className="absolute top-0 right-0 z-30 overflow-hidden w-28 h-28 pointer-events-none">
      <div
        className="absolute top-[14px] right-[-32px] w-[160px] text-center rotate-45 font-pixel tracking-widest text-white py-0.5"
        style={{
          background: isCancel
            ? "linear-gradient(135deg, hsl(30 55% 35%), hsl(30 45% 25%))"
            : "linear-gradient(135deg, hsl(0 55% 35%), hsl(0 45% 25%))",
          boxShadow: "0 2px 6px rgba(0,0,0,0.5)",
          fontSize: "7px",
          paddingLeft: "2em",
        }}
      >
        {isCancel ? "CANCELADO" : "VENDIDO"}
      </div>
    </div>
  );
};

export default SoldRibbon;
